export default __webpack_public_path__ + "static/media/HDTX_Announcement of GMS 2024.afcd0f8c.pdf";